import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditDepartmentsReady} from '../redux/departments'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


import {CostCenters,Employees} from './DropDowns/index'


import {EntityStatus} from '../../../common/DropDowns/index'

//import * as Helpers from '../../../common/helpers'

class AddEditDepartments extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        departmentsName: "",
        costCenter: "",
        head: "",
        status: "",

        departmentsNameErrorText: false,
        departmentsNameErrorData: '',

        costCenterErrorText: false,
        costCenterErrorData: '',

        headErrorText: false,
        headErrorData: '',

        statusErrorText: false,
        statusErrorData: '',

        subTitle: Constants.ADD_DEPARTMENT

    }

    this.isComponentStillMounted = true

    this.departmentsNameComponent = null
    this.departmentsNameSection = null

    this.costCenterComponent = null
    this.costCenterSection = null


    this.headComponent = null
    this.headSection = null

    this.statusComponent = null
    this.statusSection = null

    

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditDepartmentsReady(false))

    if (this.props.departments && this.props.departments.departmentsSelectedId && this.props.departments.departmentsSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_DEPARTMENT))
        this.setState({
            subTitle: "Edit Department",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_DEPARTMENT))
        this.setState({
            subTitle: "Add Department"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.departments && this.props.departments.departmentsSelectedId && this.props.departments.departmentsSelectedId !== null) {
        this.getDepartmentsById(this.props.departments.departmentsSelectedId)
    }else{

    this.props.dispatch(addEditDepartmentsReady(true))
    }
}

componentDidMount() {

        this.departmentsNameSection = ReactDOM.findDOMNode(this.refs.departmentsNameSection)

        this.costCenterSection = ReactDOM.findDOMNode(this.refs.costCenterSection)

        this.headSection = ReactDOM.findDOMNode(this.refs.headSection)

        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditDepartmentsReady(false))
    let data = {}

    let departmentsNameObject = this.mandateValidation("departmentsName", Constants.FORM_INPUT)
    if (departmentsNameObject.status) {
        data.name = this.departmentsNameComponent.value
    } else {

         this.props.dispatch(addEditDepartmentsReady(true))
        return
    }

    let costCenterObject = this.mandateValidation("costCenter", Constants.FORM_SELECT)
    if (costCenterObject.status) {
        data.cost_center_id = this.costCenterComponent.value
    } else {
        this.props.dispatch(addEditDepartmentsReady(true))
        return
    }


    let headObject = this.mandateValidation("head", Constants.FORM_SELECT)
    if (headObject.status) {
        data.head_id = this.headComponent.value
    } else {
        this.props.dispatch(addEditDepartmentsReady(true))
        return
    }


    let statusObject = this.mandateValidation("status", Constants.FORM_SELECT)
    if (statusObject.status) {
        data.status = this.statusComponent.value
    } else {
        this.props.dispatch(addEditDepartmentsReady(true))
        return
    }


    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editDepartments(apiPayloadData,this.state.departmentsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditDepartmentsReady(true))
                        this.props.history.push("/dashboard/departments/list")
                    } else {

                        this.props.dispatch(addEditDepartmentsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditDepartmentsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addDepartments(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditDepartmentsReady(true))
                        this.props.history.push("/dashboard/departments/list")
                    } else {

                        this.props.dispatch(addEditDepartmentsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditDepartmentsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getDepartmentsById = (id) => {
    apiService.getDepartmentsById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        departmentsData: responseData.data ,
                        departmentsName : responseData.data.name  ,
                        costCenter : responseData.data.cost_center.id ,
                        head : responseData.data.department_head.id   ,
                        status : responseData.data.status               
                    })

                    if (this.isComponentStillMounted) {
                        this.departmentsNameComponent.value=responseData.data.name
                        this.statusComponent.value=responseData.data.status
                        this.costCenterComponent.value=responseData.data.cost_center.id
                        this.headComponent.value=responseData.data.department_head.id
                    }

                    this.props.dispatch(addEditDepartmentsReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditDepartmentsReady(true))
        })
}




 costCentersChange = (data) => {
    this.costCenterComponent.value=data.value
        this.setState({
            costCenter :data.value,
            costCenterErrorText: false,
            costCenterErrorData: ''
        })
        this.costCenterSection.className= this.costCenterSection.className.replace(" has-error", "")
    }



 employeeChange = (data) => {
    this.headComponent.value=data.value
        this.setState({
            head :data.value,
            headErrorText: false,
            headErrorData: ''
        })
        this.headSection.className= this.headSection.className.replace(" has-error", "")
    }

    entityStatusChange = (data) => {
    
        this.statusComponent.value=data.value
            this.setState({
                status :data.value,
                statusErrorText: false,
                statusErrorData: ''
            })
            this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }



    







    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.departmentsNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Department Name" type="text" ref={el => this.departmentsNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("departmentsName")}} />
                                                        <span className="help-block"style={{display: this.state.departmentsNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.departmentsNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.costCenterSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Cost Center *</label>
                                                    <div className="col-sm-9" ref={el => this.costCenterComponent = el}>
                                                        
                                                         <CostCenters costCentersChange={this.costCentersChange} selectedValue={this.state.costCenter} />

                                                        <span className="help-block"style={{display: this.state.costCenterErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.costCenterErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                            

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.headSection = el}>
                                                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department Head *</label>
                                                        <div className="col-sm-9" ref={el => this.headComponent = el}>
                                                            
                                                             <Employees employeeChange={this.employeeChange} selectedValue={this.state.head} />

                                                            <span className="help-block"style={{display: this.state.headErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                {this.state.headErrorData}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.statusSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status *</label>
                                                    <div className="col-sm-9" ref={el => this.statusComponent = el}>
                                                        
                                                         <EntityStatus type="DEPARTMENT" entityStatusChange={this.entityStatusChange} selectedValue={this.state.status} />

                                                        <span className="help-block"style={{display: this.state.statusErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.statusErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        departments: state.departments,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditDepartments))


// WEBPACK FOOTER //
// ./src/modules/Departments/Components/AddEditDepartments.js